import React, { useCallback, useEffect, useState } from 'react';
import { Navbar as NavbarComponent } from 'decentraland-ui2';
import { getChainName } from '@dcl/schemas/dist/dapps/chain-id';
import { ProviderType } from '@dcl/schemas';
import { getAnalytics } from '../../modules/analytics/utils';
import { t } from '../../modules/translation';
import UnsupportedNetworkModal from '../UnsupportedNetworkModal';
import { getAvailableChains } from '../../lib/chainConfiguration';
import { getConnectedProviderType } from '../../lib';
import { getBaseUrl } from '../../lib/utils';
import ChainProvider from '../ChainProvider';
import { CHANGE_NETWORK, NAVBAR_DOWNLOAD_EVENT, DROPDOWN_MENU_BALANCE_CLICK_EVENT, DROPDOWN_MENU_DISPLAY_EVENT, DROPDOWN_MENU_ITEM_CLICK_EVENT, DROPDOWN_MENU_SIGN_OUT_EVENT, NAVBAR_DOWNLOAD_EVENT_PLACE } from './constants';
import { NAVBAR_CLICK_EVENT } from './constants';
import useNotifications from '../../hooks/useNotifications';
import { NavbarContainer } from './Navbar2.styled';
const BASE_URL = getBaseUrl();
const Navbar2 = ({ appChainId, isSwitchingNetwork, withNotifications, withChainSelector, identity, docsUrl = 'https://docs.decentraland.org', enablePartialSupportAlert = true, walletError, ...props }) => {
    const expectedChainName = getChainName(appChainId);
    const analytics = getAnalytics();
    const { isModalOpen, isNotificationsOnboarding, modalActiveTab, isLoading, notifications, handleNotificationsOpen, handleOnBegin, handleOnChangeModalTab, handleRenderProfile } = useNotifications(identity, withNotifications || false);
    const handleSwitchNetwork = useCallback(() => {
        props.onSwitchNetwork(appChainId);
    }, []);
    const [chainSelected, setChainSelected] = useState(undefined);
    useEffect(() => {
        if (walletError && chainSelected && withChainSelector) {
            setChainSelected(undefined);
        }
    }, [walletError, chainSelected, withChainSelector]);
    const handleSwitchChain = useCallback((chainId) => {
        setChainSelected(chainId);
        props.onSwitchNetwork(chainId, props.chainId);
        analytics?.track(CHANGE_NETWORK, {
            from_chain_id: props.chainId,
            to_chain_id: chainId
        });
    }, [analytics]);
    const handleClickBalance = useCallback((e, network) => {
        e.preventDefault();
        analytics?.track(DROPDOWN_MENU_BALANCE_CLICK_EVENT, { network });
        setTimeout(() => {
            window.open(`${BASE_URL}/account`, '_blank', 'noopener');
        }, 300);
    }, [analytics]);
    const handleClickNavbarItem = useCallback((_e, options) => {
        analytics?.track(NAVBAR_CLICK_EVENT, options);
    }, [analytics]);
    const handleClickUserMenuItem = useCallback((_e, options) => {
        analytics?.track(DROPDOWN_MENU_ITEM_CLICK_EVENT, options);
    }, [analytics]);
    const handleClickDownload = useCallback((_e, options) => {
        analytics?.track(NAVBAR_DOWNLOAD_EVENT, {
            ...options,
            place: NAVBAR_DOWNLOAD_EVENT_PLACE
        });
    }, [analytics]);
    const handleClickOpen = useCallback((_e, track_uuid) => {
        analytics?.track(DROPDOWN_MENU_DISPLAY_EVENT, { track_uuid });
    }, [analytics]);
    const handleClickSignIn = useCallback((_e) => {
        props.onSignIn();
    }, [analytics]);
    const handleClickSignOut = useCallback((_e, track_uuid) => {
        analytics?.track(DROPDOWN_MENU_SIGN_OUT_EVENT, { track_uuid });
        setTimeout(() => {
            props.onSignOut();
        }, 300);
    }, [analytics]);
    return (React.createElement(NavbarContainer, null,
        React.createElement(ChainProvider, null, ({ chainId, isUnsupported }) => (React.createElement(React.Fragment, null,
            React.createElement(NavbarComponent, { ...props, notifications: withNotifications
                    ? {
                        locale: props.locale,
                        isLoading,
                        isOnboarding: isNotificationsOnboarding,
                        isOpen: isModalOpen,
                        items: notifications,
                        activeTab: modalActiveTab,
                        onClick: handleNotificationsOpen,
                        onClose: handleNotificationsOpen,
                        onBegin: handleOnBegin,
                        onChangeTab: (_, tab) => handleOnChangeModalTab(tab),
                        renderProfile: handleRenderProfile
                    }
                    : undefined, onClickBalance: handleClickBalance, onClickNavbarItem: handleClickNavbarItem, onClickUserMenuItem: handleClickUserMenuItem, onClickOpen: handleClickOpen, onClickSignIn: handleClickSignIn, onClickSignOut: handleClickSignOut, onClickDownload: handleClickDownload, ...(withChainSelector && {
                    chains: getAvailableChains(),
                    selectedChain: chainId ?? undefined,
                    chainBeingConfirmed: chainSelected !== chainId ? chainSelected : undefined,
                    onSelectChain: handleSwitchChain,
                    i18nChainSelector: {
                        title: t('@dapps.chain_selector.title'),
                        connected: t('@dapps.chain_selector.connected'),
                        confirmInWallet: getConnectedProviderType() === ProviderType.INJECTED // for injected ones, show label to confirm in wallet, the rest won't ask for confirmation
                            ? t('@dapps.chain_selector.confirm_in_wallet')
                            : t('@dapps.chain_selector.switching')
                    }
                }) }),
            isUnsupported ? (React.createElement(UnsupportedNetworkModal, { chainName: getChainName(chainId), expectedChainName: expectedChainName, isSwitchingNetwork: isSwitchingNetwork, onSwitchNetwork: handleSwitchNetwork })) : null)))));
};
export default React.memo(Navbar2);
//# sourceMappingURL=Navbar2.js.map